<section class="login  bg-primary common-img-bg">
    <div class="container-login">
        <div class="login-card  auth-body">
            <form 
                class="md-float-material" 
                (ngSubmit)="submitResetPassword()" #formResetpass="ngForm" 
                novalidate>
                <div class="text-center">
                    <img src="../assets/images/logo_login.png" alt="logo.png">
                </div>
                <div class="auth-box">
                    <div class="row m-b-20">
                        <div class="col-md-12">
                            <h3 class="text-left txt-primary">Restablecer Contraseña</h3>
                        </div>
                    </div>
                    <hr />
                    <div class="input-group">
                        <input 
                            type="password" 
                            class="form-control" 
                            (paste)="$event.preventDefault()"
                            placeholder='Contraseña' 
                            name="Password"
                            [(ngModel)]="resetpassForm.Password" #passwordInput="ngModel" 
                            required minlength="12"
                            pattern="(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[@$!%*?&]).{8,}"
                            (ngModelChange)="validatePassword(passwordInput)"
                        >
                        <span class="md-line"></span>
                    </div>
                    <div *ngIf="passwordInput.invalid" class="error-messages">
                        <p *ngIf="passwordInput.errors['required']">
                            La contraseña es obligatoria.
                        </p>
                        <p *ngIf="passwordInput.errors['minlength']">
                            La contraseña debe tener al menos 12 caracteres.
                        </p>
                        <p *ngIf="passwordInput.errors['pattern'] && !hasUpperCase">
                            La contraseña debe contener al menos una letra mayúscula.
                        </p>
                        <p *ngIf="passwordInput.errors['pattern'] && !hasLowerCase">
                            La contraseña debe contener al menos una letra minúscula.
                        </p>
                        <p *ngIf="passwordInput.errors['pattern'] && !hasNumber">
                            La contraseña debe contener al menos un número.
                        </p>
                        <p *ngIf="passwordInput.errors['pattern'] && !hasSpecialChar">
                            La contraseña debe contener al menos un caracter especial (e.g., @$!%*?&).
                        </p>
                    </div>
                    <div class="row m-t-30">
                        <div class="col-md-6">
                            <button 
                                type="submit"
                                class="btn btn-primary btn-md btn-block waves-effect text-center m-b-20"
                                (click)="cancelar()"
                            >
                                Cancelar
                            </button>
                        </div>
                        <div class="col-md-6">
                            <button 
                                type="submit" 
                                [disabled]="!isValid" 
                                [ngClass]="{
                                'btn-primary': isValid,
                                'btn-secondary': !isValid
                                }" 
                                class="btn btn-md btn-block waves-effect text-center m-b-20"
                            >
                                Restablecer
                            </button>

                        </div>
                    </div>
                </div>
                <div class="text-right" id="divVersionId">
                </div>
            </form>
        </div>
    </div>
</section>